module.exports = __webpack_public_path__ + "img/ikon_mussla.32368e0a.svg";